
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 5a.75.75 0 00-1.5 0h1.5zm-1.5.01a.75.75 0 001.5 0h-1.5zm1.5 6.99a.75.75 0 00-1.5 0h1.5zm-1.5.01a.75.75 0 001.5 0h-1.5zm1.5 6.99a.75.75 0 00-1.5 0h1.5zm-1.5.01a.75.75 0 001.5 0h-1.5zM12 5.25a.25.25 0 01-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5zM11.75 5a.25.25 0 01.25-.25v-1.5A1.75 1.75 0 0010.25 5h1.5zm.25-.25a.25.25 0 01.25.25h1.5A1.75 1.75 0 0012 3.25v1.5zm.25.25a.25.25 0 01-.25.25v1.5A1.75 1.75 0 0013.75 5h-1.5zM12 12.25a.25.25 0 01-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5zm-.25-.25a.25.25 0 01.25-.25v-1.5A1.75 1.75 0 0010.25 12h1.5zm.25-.25a.25.25 0 01.25.25h1.5A1.75 1.75 0 0012 10.25v1.5zm.25.25a.25.25 0 01-.25.25v1.5A1.75 1.75 0 0013.75 12h-1.5zM12 19.25a.25.25 0 01-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5zm-.25-.25a.25.25 0 01.25-.25v-1.5A1.75 1.75 0 0010.25 19h1.5zm.25-.25a.25.25 0 01.25.25h1.5A1.75 1.75 0 0012 17.25v1.5zm.25.25a.25.25 0 01-.25.25v1.5A1.75 1.75 0 0013.75 19h-1.5zm-1-14v.01h1.5V5h-1.5zm0 7v.01h1.5V12h-1.5zm0 7v.01h1.5V19h-1.5z"}})])
          )
        }
      }
    